import React, { memo } from 'react';
import {
  Card,
  CircularProgress,
  Collapse,
  Divider,
  Icon,
  IconButton,
  LoadingButton,
  Stack,
  Typography
} from 'investira.react.components';
import { formats } from 'investira.sdk';
import { formatFileSize } from './avaliacoesGestorEdit.helpers';

const AvaliacoesGestorEditAnexosPanel = memo(props => {
  const {
    anexos,
    disabledButtons,
    fluxoAcaoEmAndamento,
    todasRespondidas,
    onOpenAnexos,
    onAddAnexos,
    onToggleGrupoQuestao,
    onOpenRemoveAnexoDialog,
    onOpenAssinaturaDialog
  } = props;

  return (
    <Stack
      id="anexos"
      direction="column"
      gap={2}
      sx={{
        position: 'sticky',
        top: 24,
        alignSelf: 'flex-start',
        maxHeight: 'calc(100vh - 24px)',
        overflowY: 'auto',
        minWidth: '340px',
        maxWidth: '340px',
        width: '100%'
      }}>
      <Stack gap={1.5}>
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
          Anexos
        </Typography>
        <Card
          onClick={onOpenAnexos}
          sx={{
            p: 2,
            border: '1px dashed',
            borderColor: 'divider',
            cursor: 'pointer',
            '&:hover': { borderColor: 'primary.main', backgroundColor: 'action.hover' }
          }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Icon iconName="upload" size={18} />
              <Typography variant="body2">
                Clique para anexar arquivos {anexos.total ? `(${anexos.total})` : ''}
              </Typography>
            </Stack>
            <LoadingButton
              id="avaliacao-anexo"
              size="small"
              variant="outlined"
              onClick={pEvent => {
                pEvent.stopPropagation();
                onOpenAnexos();
              }}
              sx={{ px: 2 }}>
              Selecionar
            </LoadingButton>
          </Stack>
        </Card>
        <input ref={anexos.inputRef} type="file" multiple hidden onChange={onAddAnexos} />
        {(anexos.avaliacao.length > 0 || anexos.questoes.length > 0) && (
          <Stack gap={1}>
            {anexos.agrupados.map(pGrupo => {
              const xGrupoAberto = anexos.gruposAbertos[pGrupo.groupKey] !== false;

              return (
                <Card key={pGrupo.groupKey} sx={{ p: 1.25 }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
                    <Stack minWidth={0}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}>
                        {pGrupo.label} ({pGrupo.anexos.length})
                      </Typography>
                    </Stack>
                    <IconButton
                      size="small"
                      color="primary"
                      data-testid={`toggle-grupo-questao-${pGrupo.groupKey}`}
                      aria-label={
                        xGrupoAberto ? 'Minimizar grupo de anexos' : 'Expandir grupo de anexos'
                      }
                      onClick={() => onToggleGrupoQuestao(pGrupo.groupKey)}>
                      <Icon
                        iconName={xGrupoAberto ? 'arrow-up' : 'arrow-down'}
                        size={14}
                        color="primary"
                      />
                    </IconButton>
                  </Stack>
                  <Collapse in={xGrupoAberto}>
                    <Stack gap={1} mt={1}>
                      {pGrupo.anexos.map((pAnexo, pIndex) => (
                        <Card
                          key={pAnexo.itemKey || `${pGrupo.groupKey}-${pIndex}`}
                          sx={{ p: 1.25 }}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            gap={1}>
                            <Stack minWidth={0}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: 500,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}>
                                {pAnexo.nome || 'Arquivo'}
                              </Typography>
                              <Typography variant="caption" color="textSecondary">
                                {pAnexo.tipo === 'persistido'
                                  ? `${
                                      pGrupo.questionId
                                        ? `Questão ${pGrupo.questionId}`
                                        : 'Anexo da avaliação'
                                    }${
                                      pAnexo.created
                                        ? ` • ${formats.formatDateCustom(
                                            pAnexo.created,
                                            'DD/MM/YYYY'
                                          )}`
                                        : ''
                                    }`
                                  : `Questão ${pGrupo.questionId} • ${formatFileSize(
                                      pAnexo.tamanho
                                    )}`}
                              </Typography>
                            </Stack>
                            <IconButton
                              size="small"
                              color="error"
                              disabled={pAnexo.uploading}
                              data-testid={
                                pAnexo?.avaliacao_upload_id
                                  ? `delete-anexo-${pAnexo.avaliacao_upload_id}`
                                  : undefined
                              }
                              onClick={() => onOpenRemoveAnexoDialog(pAnexo)}>
                              {pAnexo.uploading ? (
                                <CircularProgress size={16} />
                              ) : (
                                <Icon iconName="delete" size={16} />
                              )}
                            </IconButton>
                          </Stack>
                        </Card>
                      ))}
                    </Stack>
                  </Collapse>
                </Card>
              );
            })}
          </Stack>
        )}
      </Stack>
      {/* <Divider />
      <LoadingButton
        variant="contained"
        color="primary"
        startIcon={<Icon iconName="paper_plane" size={16} />}
        size="small"
        sx={{ px: 2 }}
        data-testid="abrir-assinatura-entrega"
        onClick={onOpenAssinaturaDialog}
        disabled={!todasRespondidas || disabledButtons || fluxoAcaoEmAndamento}>
        Entregar
      </LoadingButton> */}
    </Stack>
  );
});

export default AvaliacoesGestorEditAnexosPanel;
